<template>
    <AppLayout>
        <div class="bg-white">
            <Container>
                <nav aria-label="Breadcrumb" class="pt-8">
                    <ol role="list" class="flex items-center gap-2 text-sm">
                        <li v-for="breadcrumb in breadcrumbs" :key="breadcrumb.id" class="flex items-center gap-2">
                            <a :href="breadcrumb.href" class="font-medium text-gray-500 hover:text-primary-600">{{ breadcrumb.name }}</a>
                            <ChevronRightIcon class="size-4 text-gray-300" aria-hidden="true" />
                        </li>
                        <li v-if="product" class="font-medium text-gray-900">{{ product.name }}</li>
                    </ol>
                </nav>

                <div v-if="product" class="mt-8 grid grid-cols-1 gap-x-12 gap-y-10 pb-24 lg:grid-cols-2">
                    <div class="lg:sticky lg:top-24 lg:self-start">
                        <img :src="product.image" :alt="product.imageAlt"
                            class="aspect-4/3 w-full rounded-2xl object-cover shadow-lg ring-1 ring-gray-900/5" />
                    </div>

                    <div>
                        <h1 class="text-3xl font-semibold tracking-tight text-gray-900 sm:text-4xl">{{ product.name }}</h1>

                        <div v-if="reviews" class="mt-4 flex items-center">
                            <div class="flex items-center">
                                <StarIcon v-for="rating in [0, 1, 2, 3, 4]" :key="rating"
                                    :class="[reviews.average > rating ? 'text-accent-500' : 'text-gray-200', 'size-5 shrink-0']"
                                    aria-hidden="true" />
                            </div>
                            <p class="sr-only">{{ reviews.average }} out of 5 stars</p>
                            <a :href="reviews.href" class="ml-3 text-sm font-medium text-primary-600 hover:text-primary-500">{{
                                reviews.totalCount }} reviews</a>
                        </div>

                        <div class="cms-content mt-6">
                            <p>{{ product.description }}</p>
                        </div>

                        <div class="mt-8 rounded-2xl bg-gray-50 p-6 ring-1 ring-gray-900/5">
                            <p class="text-sm text-gray-600">Ready to start learning? Reserve your seat and pick a
                                schedule that works for you.</p>
                            <Button class="mt-4" variant="primary" size="lg" block
                                @click="router.push({ name: 'checkout', params: { slug: product.slug } })">
                                Enroll now
                            </Button>
                        </div>
                    </div>
                </div>

                <div v-else class="py-24 text-center text-sm text-gray-500">Loading course…</div>
            </Container>
        </div>
    </AppLayout>
</template>

<script setup>
import { ref } from 'vue';
import { StarIcon } from '@heroicons/vue/20/solid';
import { ChevronRightIcon } from '@heroicons/vue/20/solid';
import { onMounted } from 'vue';
import { getProductBySlug } from '@/services/productService';
import { useRouter } from 'vue-router';
import AppLayout from '@/components/layouts/AppLayout.vue';
import Container from '@/components/ui/Container.vue';
import Button from '@/components/ui/Button.vue';

const router = useRouter();
const productSlug = router.currentRoute.value.params.slug;

const product = ref(null);
const reviews = null;
const breadcrumbs = [
    { id: 1, name: 'Courses', href: '/courses' },
]

onMounted(async () => {
    const response = await getProductBySlug(productSlug);
    product.value = response.data;
});
</script>
